module.exports = __webpack_public_path__ + "static/carousel-5-17762d28fe47f84bc8bdf72a264bc4a3.jpg";